import { LoadingSpinner } from '@psyomics/ui-components';

import { ReferralsView } from './referrals-view';
import { useFilters } from './use-filters';
import { useOrganisationServiceCodes } from './use-organisation-service-codes';
import { usePagingAndSorting } from './use-paging-and-sorting';
import { useReferralsQuery } from './use-referrals';

const PAGE_SIZE = 10;

const Referrals = ({ isSummary = false }: { readonly isSummary?: boolean }) => {
  const { pagination, setPagination, sorting, setSorting, resetPageIndex } = usePagingAndSorting(PAGE_SIZE);
  const { serviceCodes } = useOrganisationServiceCodes();
  const allFilters = useFilters(resetPageIndex, serviceCodes);
  const showCompletedOnly = isSummary;
  const { result } = useReferralsQuery({
    allFilters,
    pageIndex: pagination.pageIndex,
    pageSize: pagination.pageSize,
    showCompletedOnly,
    sortAscending: !sorting[0]?.desc,
    sortBy: sorting[0]?.id,
  });

  if (!result) return <LoadingSpinner />;

  return (
    <ReferralsView
      {...allFilters}
      isSummary={isSummary}
      onPaginationChange={setPagination}
      onSortingChange={setSorting}
      pagination={pagination}
      referrals={result.referrals}
      sorting={sorting}
      totalCount={result.totalCount}
    />
  );
};

export { Referrals };
